import { SingleAuthorTemplate } from './single-author';
import { MultipleAuthorTemplate } from './multi-author';
import { PhotoPrioritySingleAuthorTemplate } from './photo-priority-single-author/photo-priority-single-author';
import { PhotoPriorityMultiAuthorTemplate } from './photo-priority-multi-author/photo-priority-multi-author';
import { PhotoLowPrioritySingleAuthorTemplate } from './photo-low-priority-single-author/photo-low-priority-single-author';
import { PhotoLowPriorityMultiAuthorTemplate } from './photo-low-priority-multi-author/photo-low-priority-multi-author';

export function getAuthorTemplate(template) {
  switch(template) {
    case 'single-author': return SingleAuthorTemplate;
    case 'multi-author': return MultipleAuthorTemplate;
    case 'photo-priority-single-author': return PhotoPrioritySingleAuthorTemplate;
    case 'photo-priority-multi-author': return PhotoPriorityMultiAuthorTemplate;
    case 'photo-low-priority-single-author': return PhotoLowPrioritySingleAuthorTemplate;
    case 'photo-low-priority-multi-author': return PhotoLowPriorityMultiAuthorTemplate;
    default: return SingleAuthorTemplate;
  }
}